import { render, staticRenderFns } from "./ManageEmail.vue?vue&type=template&id=8a7f8768&scoped=true"
import script from "./ManageEmail.vue?vue&type=script&lang=js"
export * from "./ManageEmail.vue?vue&type=script&lang=js"
import style0 from "./ManageEmail.vue?vue&type=style&index=0&id=8a7f8768&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a7f8768",
  null
  
)

export default component.exports